var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#919090",
    d: "m12 14.475l7.35-7.35q.375-.375.888-.363t.887.388t.375.888t-.375.887l-7.675 7.7q-.3.3-.675.45t-.75.15t-.75-.15t-.675-.45l-7.7-7.7q-.375-.375-.363-.888t.388-.887t.888-.375t.887.375z",
    transform: "rotate(12 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMore);
export default __webpack_public_path__ + "static/media/arrow-more.5adf0afbf263c0abe4c601be1ae5fd82.svg";
export { ForwardRef as ReactComponent };